import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  Typography,
  CircularProgress,
} from '@mui/material';

const AdminPanel = () => {
  const [uploading, setUploading] = useState(false);

  const handleImageUpload = async (event) => {
    const files = event.target.files;
    setUploading(true);

    try {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append('images', files[i]);
      }

      const response = await fetch('/.netlify/functions/uploadImages', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        alert('Images uploaded successfully!');
      }
    } catch (error) {
      console.error('Error uploading images:', error);
      alert('Error uploading images');
    } finally {
      setUploading(false);
    }
  };

  return (
    <Container maxWidth="md">
      <Box sx={{ padding: 4 }}>
        <Typography variant="h4" gutterBottom>
          Admin Panel
        </Typography>
        <Box
          sx={{
            border: '2px dashed #ccc',
            borderRadius: 2,
            padding: 4,
            textAlign: 'center',
            marginTop: 2,
          }}
        >
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={handleImageUpload}
            style={{ display: 'none' }}
            id="image-upload"
          />
          <label htmlFor="image-upload">
            <Button
              variant="contained"
              component="span"
              disabled={uploading}
              sx={{ marginBottom: 2 }}
            >
              {uploading ? <CircularProgress size={24} /> : 'Upload Images'}
            </Button>
          </label>
          <Typography variant="body2" color="textSecondary">
            Drag and drop images here or click to select files
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default AdminPanel; 